import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import Card from '@/components/base/Card';

interface Counts {
  loads: number;
  events: number;
}

export default function HomePage() {
  const [counts, setCounts] = useState<Counts>({ loads: 0, events: 0 });
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { count: loads, error: le } = await supabase
          .from('loads')
          .select('id', { count: 'exact', head: true });
        const { count: events, error: ee } = await supabase
          .from('events')
          .select('id', { count: 'exact', head: true });
        if (le || ee) throw le || ee;
        if (active) setCounts({ loads: loads ?? 0, events: events ?? 0 });
      } catch (e) {
        if (active) setError('Não foi possível obter os indicadores.');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-4xl">Início</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Bem-vindo ao Portal Parceiros da FileIt.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card title="Cargas">
          {loading ? (
            <span className="text-2xl font-semibold">…</span>
          ) : (
            <span className="text-2xl font-semibold">{counts.loads}</span>
          )}
        </Card>
        <Card title="Eventos">
          {loading ? (
            <span className="text-2xl font-semibold">…</span>
          ) : (
            <span className="text-2xl font-semibold">{counts.events}</span>
          )}
        </Card>
        <Card title="Estado">
          <span className="inline-flex items-center gap-2 text-sm">
            <span className="h-2.5 w-2.5 rounded-full bg-accent" />
            Base de dados ligada
          </span>
        </Card>
      </div>

      {error && (
        <p className="rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-700">
          {error}
          <button className="ml-3 cursor-pointer font-medium underline" onClick={() => window.location.reload()}>
            Tentar de novo
          </button>
        </p>
      )}
    </div>
  );
}